import { render, staticRenderFns } from "./Residences.vue?vue&type=template&id=3c76a9c8&scoped=true&"
import script from "./Residences.vue?vue&type=script&lang=js&"
export * from "./Residences.vue?vue&type=script&lang=js&"
import style0 from "./Residences.vue?vue&type=style&index=0&id=3c76a9c8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c76a9c8",
  null
  
)

export default component.exports